import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import * as types from '../actionTypes/dealLockingActionTypes';

/**
 * Sets lock payment inputs in Sales View for a specific deal type
 * Locks/unlocks credit rating and terms editing for the specified deal type
 * @param dealType - The deal type to lock/unlock (FINANCE or LEASE)
 * @param locked - Whether to lock (true) or unlock (false) payment inputs
 * @returns Action with lock settings payload, or no-op action if invalid parameters
 */
export const setLockPaymentInputsInSV = (dealType: typeof FINANCE | typeof LEASE, locked: boolean) => {
    // Validate dealType - only FINANCE or LEASE are supported
    if (dealType !== FINANCE && dealType !== LEASE) {
        // Return a no-op action (@@NOOP is a Redux convention for actions that should be ignored by all reducers and middleware)
        return { type: '@@NOOP' };
    }

    // Convert to lowercase key for state structure
    const dealTypeKey = dealType.toLowerCase() as 'finance' | 'lease';

    return {
        type: types.SET_LOCK_PAYMENT_INPUTS_IN_SV,
        payload: {
            [dealTypeKey]: locked
        },
        meta: {
            middleware: {
                payment: false
            }
        }
    };
};

/**
 * Dispatches CDL analytics event when user clicks lock/unlock button.
 * This action does not change state - only triggers CDL analytics.
 * @param isLocking - Whether user is locking (true) or unlocking (false)
 */
export const lockPaymentInputsClicked = (isLocking: boolean) => ({
    type: types.LOCK_PAYMENT_INPUTS_CLICKED,
    payload: { isLocking }
});
